const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMhubLogoDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 138,
    height: 30,
    viewBox: "0 0 138 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MHub_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_546",
    "data-name": "Group 546"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M0,15.517V30L14.482,15.517Z",
    style: {
      fill: "#00a3c0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M15.517,15.517,30,30V15.517Z",
    style: {
      fill: "#18af94"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M45.516,15.517,31.034,30V15.517Z",
    style: {
      fill: "#18af94"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M46.55,15.517,61.033,30V15.517Z",
    style: {
      fill: "#2e944a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_550",
    "data-name": "Group 550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M0,14.483H14.482V0Z",
    style: {
      fill: "#00a3c0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_551",
    "data-name": "Group 551"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M45.516,0,31.033,14.483H45.516Z",
    style: {
      fill: "#95cca5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    "data-name": "Group 552"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M15.517,14.483H30L15.517,0Z",
    style: {
      fill: "#95cca5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M46.55,0V14.482H61.033Z",
    style: {
      fill: "#2e944a"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M98.614,21.717V16.351h-3.54v5.366H91.745V8.169h3.329v5.214h3.54V8.169h3.33V21.717Z",
    style: {
      fill: "#686868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.9,21.831a4.835,4.835,0,0,1-5.119-4.871V8.169h3.33v8.715a1.737,1.737,0,0,0,1.789,1.979,1.764,1.764,0,0,0,1.827-1.979V8.169h3.329V16.96A4.866,4.866,0,0,1,114.9,21.831Z",
    style: {
      fill: "#686868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.776,21.717h-5.9V8.169h5.613c2.817,0,4.32,1.579,4.32,3.92a3.261,3.261,0,0,1-1.484,2.682A3.154,3.154,0,0,1,138,17.721C138,20.309,136.192,21.717,133.776,21.717Zm-.5-10.561h-2.074v2.208h2.074a1.108,1.108,0,1,0,0-2.208Zm.171,5.195h-2.245v2.378h2.245a1.118,1.118,0,0,0,1.218-1.2A1.1,1.1,0,0,0,133.452,16.351Z",
    style: {
      fill: "#686868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4,21.717V15.229L79.48,18.578H77.349l-1.922-3.349v6.488H72.1V8.169H75.37l3.044,5.975,3.045-5.975h3.273V21.717Z",
    style: {
      fill: "#343434"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMhubLogoDesktop);
export default __webpack_public_path__ + "static/media/mhub_logo_desktop.3bc36aa5f4e63f9bf0c0c276d51ef5e1.svg";
export { ForwardRef as ReactComponent };